import * as React from 'react';
import { Component } from 'react';
import { IdentityService } from '../../services/IdentityService';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { LoaderComponent } from '../../controls/Loader';
import { connect } from 'react-redux';
import { IProfileInfo } from '../../models/IProfileInfo';
import { SetProfileInfo } from '../../actions/ActionsIndex';
import { ShowStatusBar } from './GlobalStatusBar';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import ReCAPTCHA from 'react-google-recaptcha';


export function ShowLoginModal() {
    if (modalComponent != null) {
        modalComponent.ShowModal();
    }
}

let modalComponent: GlobalLoginModalComponent | null = null;

interface IProps {
    HandleLogin: (info: IProfileInfo) => void
}

interface IState {
    Visible: boolean,
    Login: string,
    Password: string,
    LoaderVisible: boolean,
	token: string,
	token2: string,
	refreshReCaptcha: boolean,
	reCaptchaV3Error: boolean,
}

class GlobalLoginModalComponent extends Component<IProps, IState> {
	private refReCAPTCHA;

    constructor(props) {
        super(props);

        this.state = {
            Visible: false,
            LoaderVisible: false,
            Login: '',
            Password: '',
			token: '',
			token2: '',
			refreshReCaptcha: false,
			reCaptchaV3Error: false,
        }

        this.OnAbortClick = this.OnAbortClick.bind(this);
        this.ShowModal = this.ShowModal.bind(this);
        this.OnSubmit = this.OnSubmit.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.OnLoginSuccess = this.OnLoginSuccess.bind(this);
        this.OnLoginError = this.OnLoginError.bind(this);
        this.OnGetProfileInfoSuccess = this.OnGetProfileInfoSuccess.bind(this);
        this.OnGetProfileInfoError = this.OnGetProfileInfoError.bind(this);
		this.onCaptchaVerify = this.onCaptchaVerify.bind(this);
		this.onCaptchaVerifyV2 = this.onCaptchaVerifyV2.bind(this);
    }

    public componentWillMount() {
        modalComponent = this;
    }

    public componentWillUnmount() {
        modalComponent = null;
    }

    public render() {
        if (this.state.Visible) {
            const { refreshReCaptcha, reCaptchaV3Error } = this.state;
            return (
                <div className="global-login-modal-component">
                    <div className="modal">
                        <div className="modal-main section">
                            <div className="close-btn" onClick={this.OnAbortClick} />
                            <div className="header">
                                <h3>Zaloguj się</h3>
                            </div>
                            <div className="form-container">
                                <LoaderComponent Visible={this.state.LoaderVisible} />
                                <form onSubmit={this.OnSubmit}>
                                    <div className="form-group">
                                        <label>Adres email</label>
                                        <input type="text" name="Login" onChange={this.OnInputChange} className="form-control" />
                                    </div>
                                    <div className="form-group">
                                        <label>Hasło</label>
                                        <input type="password" name="Password" onChange={this.OnInputChange} className="form-control" />
                                    </div>

                                    {reCaptchaV3Error && (
                                        <>
                                            <ReCAPTCHA
                                                sitekey={process.env.REACT_APP_RECAPTCHA_v2}
                                                ref={e => (this.refReCAPTCHA = e)}
                                                onChange={this.onCaptchaVerifyV2}
                                            />
                                            <br />
                                        </>
                                    )}

                                    <div className="form-group form-buttons">
                                        <input type="submit" className="std-primary-btn" value="Zaloguj się" />
                                        <br />
                                        <br />
                                        <br />
                                        <a href='/api/account/sso'>
                                            Zaloguj się jako fizjoterapeuta
                                        </a>
                                    </div>
                                    <GoogleReCaptcha
                                        onVerify={this.onCaptchaVerify}
                                        refreshReCaptcha={refreshReCaptcha}
                                    />
                                </form>
                                <br/>
                                <br/>
                                <span className='bottom-redirect small'>
                                    Ta strona jest chroniona przez reCAPTCHA firmy Google{' '}
                                    <a href="https://policies.google.com/privacy" target="_blank">Polityka prywatności</a>{' '}oraz{' '}
                                    <a href="https://policies.google.com/terms" target="_blank">Regulamin</a> mają zastosowanie.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    public ShowModal() {
        this.setState({
            Visible: true
        });
    }

    private OnAbortClick(evt) {
        this.setState({
            Visible: false,
            LoaderVisible: false
        });
    }

    private OnSubmit(event) {
        event.preventDefault();

        this.setState({
            LoaderVisible: true
        });
        const {
			Login,
			Password,
			token,
			token2,
			reCaptchaV3Error,
		} = this.state;
        
        const formData: {
			login: string;
			password: string;
			token?: string;
			token2?: string;
		} = {
			login: Login,
			password: Password,
		};

		if (reCaptchaV3Error) {
			if (token2) {
				formData.token2 = token2;
			} else {
				ShowStatusBar(
					'Error',
					'Proszę potwierdzić, że nie jesteś robotem.',
					DEFAULT_STATUS_TIMEOUT
				);
				this.setState({
					LoaderVisible: false,
				});

				return;
			}
		} else if (token) {
			formData.token = token;
		}

        let service = new IdentityService();
        service.LogIn(formData, this.OnLoginSuccess, this.OnLoginError);
    }

    private OnLoginSuccess(result: any): void {
        console.log(result);

		const { refreshReCaptcha } = this.state;
		this.setState({ refreshReCaptcha: !refreshReCaptcha });
		if (this.refReCAPTCHA) {
			this.refReCAPTCHA.reset();
		}

        if (result.status === 200) {
            let service = new IdentityService();
            service.GetProfileInfo(this.OnGetProfileInfoSuccess, this.OnGetProfileInfoError);
        } else {

        }
    }

    private OnLoginError(error: any): void {
        console.log(error);
		const { refreshReCaptcha } = this.state;
        this.setState({
            LoaderVisible: false,
            refreshReCaptcha: !refreshReCaptcha,
        });
        if (this.refReCAPTCHA) {
			this.refReCAPTCHA.reset();
		}

		if (error.response.data === 'captcha') {
			this.setState({
				reCaptchaV3Error: true,
			});

			ShowStatusBar(
				'Error',
				'Nie mogliśmy potwierdzić próby logowania. Potwierdź, że nie jesteś robotem.',
				DEFAULT_STATUS_TIMEOUT
			);
		} else if (error.response.data === 'captcha2') {
			this.setState({
				reCaptchaV3Error: true,
			});
			
 			ShowStatusBar(
				'Error',
				'Nie mogliśmy potwierdzić próby logowania. Spróbuj ponownie lub skorzystaj z innej przeglądarki.',
				DEFAULT_STATUS_TIMEOUT
			);
		} else {
            ShowStatusBar(
                'Error',
                'Próba logowania nie udała się, spróbuj ponownie.',
                DEFAULT_STATUS_TIMEOUT
            );
        }
    }

    private OnGetProfileInfoSuccess(result: any): void {
        this.props.HandleLogin(result.data.Value);
        this.setState({
            Visible: false,
            LoaderVisible: false
        });
    }

    private OnGetProfileInfoError(error: any): void {
        console.log(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Próba logowania nie udała się, spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnInputChange(event) {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

	private onCaptchaVerify(token: string) {
        console.log({token});
		this.setState({
			token,
		});
	}

	private onCaptchaVerifyV2(token2: string) {
		if (!token2 && this.refReCAPTCHA) {
			this.refReCAPTCHA.reset();
		}

		this.setState({
			token2,
		});
	}
}

export default connect(null, { HandleLogin: SetProfileInfo })(GlobalLoginModalComponent);


// WEBPACK FOOTER //
// ./src/components/Layout/GlobalLoginModal.tsx